export default __webpack_public_path__ + "check.d8ac9c9e.svg";